module.exports = __webpack_public_path__ + "img/fuwubaoz_2.7e11edfd.png";